import { Button, Stack, Typography } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import Modal, { CommonModalProps } from "..";
import { userService } from "../../../Core/Api/services";
import { useTranslation } from "react-i18next";

export type ModalConfirmCofElementProps = {
  platformId?: number;
  onConfirm?: (comment?: string, isChecked?: boolean) => void;
};

export type CofObject = {
  title: string;
  subTitle: string;
  sections: { title: string; text: string; subSections: { title: string; text: string }[] }[];
};

export type ModalConfirmCofProps = CommonModalProps<ModalConfirmCofElementProps>;

const ModalConfirmCof = React.forwardRef<any, ModalConfirmCofProps>((props, ref) => {
  const { t } = useTranslation();
  const { closeModal, onConfirm, platformId } = props;

  const [cofObject, setCofObject] = useState<CofObject | null>(null);

  useEffect(() => {
    userService.GetCof(platformId).then((response) => {
      setCofObject(response.cof);
    });
  }, []);

  const handleCancelClick = () => {
    closeModal();
  };

  const handleConfirmClick = () => {
    userService.PutCof().then((response) => {
      if (response.success) onConfirm && onConfirm();

      closeModal();
    });
  };

  const renderText = (text: string) => (
    <Stack direction={"column"} display={"flex"} spacing={0.5}>
      {text.split("\n").map((x) => (
        <Typography>{x}</Typography>
      ))}
    </Stack>
  );

  const renderCof = useMemo(
    () => (
      <Stack
        p={2}
        sx={(theme) => ({
          backgroundColor: theme.palette.background.paper,
          border: `1px solid ${theme.palette.background.alphaHover}`,
          ...theme.helpers(theme).scrollBar,
        })}
        height={"500px"}
        overflow={"scroll"}
        display={"flex"}
        flexDirection={"column"}
        alignItems={"center"}
        spacing={2}
      >
        <Typography variant="h3">{cofObject?.title}</Typography>
        <Typography variant="h4">{cofObject?.subTitle}</Typography>
        {cofObject?.sections.map((x) => (
          <Stack display={"flex"} direction={"column"} spacing={1.5}>
            <Typography variant="h5">{x.title}</Typography>
            {x.text && renderText(x.text)}
            {x.subSections &&
              x.subSections.map((y) => (
                <Stack display={"flex"} direction={"column"} spacing={1}>
                  <Typography variant="h6">{y.title}</Typography>
                  {y.text && renderText(y.text)}
                </Stack>
              ))}
          </Stack>
        ))}
      </Stack>
    ),
    [cofObject]
  );

  return (
    <Modal
      title={t("modal:title.userLicenceAgreement")}
      reference={ref}
      closeModal={handleCancelClick}
      width={680}
      footer={
        <Stack direction="row" justifyContent="space-between">
          <Button onClick={handleCancelClick}>{t("common:cancel")}</Button>
          <Button color="success" variant="outlined" onClick={handleConfirmClick}>
            {t("common:confirm")}
          </Button>
        </Stack>
      }
    >
      {renderCof}
    </Modal>
  );
});

export default ModalConfirmCof;
